import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { Component, NgZone, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { JobInfosForTimetracking } from 'server/shared/models/job';
import { ToastService } from '../../services/toast/toast.service';

@Component({
  selector: 'time-tracking-form',
  templateUrl: 'time-tracking-form.component.html',
  styleUrls: ['time-tracking-form.component.scss'],
})
export class TimeTrackingFormComponent implements OnInit {
  jobId?: string;
  secret?: string;
  isLoadingJob = true;
  isLoggedIn = false;

  subscriptions: Subscription = new Subscription();

  jobInfo?: JobInfosForTimetracking;

  timeTrackingStatus: 'TO_ADD' | 'TO_APPROVE' | 'APPROVED' = 'TO_ADD';

  @ViewChild('autosize') autosize?: CdkTextareaAutosize;

  constructor(
    private router: Router,
    private toastService: ToastService,
    private ngZone: NgZone,
    private route: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.jobId = this.route.snapshot.paramMap.get('jobId') || '';
    this.secret = this.route.snapshot.paramMap.get('secret') || '';

    if (Meteor.userId()) {
      this.isLoggedIn = true;
    }
    this.getJobInfo();
  }

  getJobInfo() {
    Meteor.call(
      'getJobInfosForTimeTracking',
      this.jobId,
      this.secret,
      (error: Meteor.Error, result: any) => {
        if (error) {
          this.toastService.add({
            type: 'ERROR',
            message: 'jobNotFound',
          });
        } else {
          this.ngZone.run(() => {
            this.jobInfo = result;
            if (
              this.jobInfo?.invitee?.timeTrackings?.some(
                (timeTracking) => timeTracking.approvedAt,
              )
            ) {
              this.timeTrackingStatus = 'APPROVED';
            } else if (
              this.jobInfo?.invitee?.timeTrackings?.some(
                (timeTracking) => timeTracking.toBeApprovedAt,
              )
            ) {
              this.timeTrackingStatus = 'TO_APPROVE';
            }
          });
        }
        this.ngZone.run(() => {
          this.isLoadingJob = false;
        });
      },
    );
  }

  updateTimeTrackingStatus() {
    if (this.jobInfo?.isCustomer) {
      this.timeTrackingStatus = 'APPROVED';
    } else {
      this.timeTrackingStatus = 'TO_APPROVE';
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
